import { nachLoeschen, type Op } from '@schnitt/shared';
import { useEditor } from './store';

/**
 * Clips löschen -- und den Abspielkopf mitnehmen (15. Oktober: „Beim
 * löschen sollte der Abspieler auch um die gelöschte Länge nach vorne
 * rutschen … zurückfallen auf den Clip links. Ans Ende“). Wohin er geht,
 * rechnet `nachLoeschen`; hier steht nur der Ablauf, den die
 * Werkzeugleiste, das Menü am Clip und die Entfernen-Taste teilen.
 *
 * Gibt zurück, wie viele Clips wirklich weg sind: eine gesperrte Spur hält
 * ihre fest.
 */
export function loescheClips(ids: readonly string[]): number {
  const s = useEditor.getState();
  if (ids.length === 0) return 0;
  const vorher = s.timeline;
  const kopf = s.playhead;
  s.dispatch(ids.map((clipId) => ({ op: 'removeClip', clipId }) as Op));
  const nachher = useEditor.getState().timeline;
  const noch = new Set(nachher.tracks.flatMap((t) => t.clips.map((c) => c.id)));
  const weg = ids.filter((id) => !noch.has(id));
  if (weg.length === 0) return 0;
  const danach = nachLoeschen(vorher, nachher, weg, kopf, nachher.settings.fps);
  if (Math.abs(danach.kopf - kopf) > 1e-6) useEditor.getState().setPlayhead(danach.kopf);
  useEditor.getState().select(danach.wahl ? [danach.wahl] : []);
  return weg.length;
}
